import api from "./api-configuration-v2";

/**
 * Kişi listesini getirir. Her zaman is_active === false olanlar gelir.
 * Ek filtreler opsiyonel olarak verilebilir: { tasiyici: true }, { kontrat: true } vs.
 */
export async function getBrand(filter = {}, is_active = true) {
    try {
        const response = await api.post("/getAllBrands"); // API endpoint
        const allBrand = response.data.data;

        // is_active !== false olanları filtrele
        const nonDeleted = allBrand.filter(brand => brand.is_active === is_active);

        // Ek filtreleri uygula (örneğin tasiyici: true)
        const finalResult = nonDeleted.filter(brand =>
            Object.entries(filter).every(([key, value]) => brand[key] === value)
        );

        return finalResult;
    } catch (error) {
        console.error("Araç marka bilgisi alınırken hata:", error);
        return [];
    }
}
